'use client';

import Image from 'next/image';
import Link from 'next/link';
import { useTranslation } from '@/lib/i18n';
import { useTheme } from '@/lib/theme';

export default function Footer() {
  const { t } = useTranslation();
  const { theme } = useTheme();

  return (
    <footer className='py-12 border-t border-border-faint bg-bg-footer px-6'>
      <div className='max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8'>
        <div className='flex items-center gap-4'>
          <Image
            src={
              theme === 'dark'
                ? '/haintz-it-solutions/rectangle-white.svg'
                : '/haintz-it-solutions/rectangle.svg'
            }
            alt='HAINTZ IT-SOLUTIONS'
            width={240}
            height={50}
            className='h-8 w-auto'
          />
          <div className='h-4 w-px bg-divider hidden md:block' />
          <div className='text-[10px] text-text-faint font-mono tracking-widest'>
            &copy; {new Date().getFullYear()} HAINTZ IT-SOLUTIONS · MARTIN
            HAINTZ
          </div>
        </div>

        <div className='flex flex-wrap justify-center md:justify-end gap-6 text-[10px] font-mono text-text-faint uppercase tracking-widest'>
          <Link
            href='/#solutions'
            className='hover:text-mint-text transition-colors'
          >
            {t('nav.solutions')}
          </Link>
          {/* <Link href="/projects" className="hover:text-mint-text transition-colors">
            {t("nav.projects")}
          </Link> */}
          <Link
            href='/partners'
            className='hover:text-mint-text transition-colors'
          >
            {t('footer.partners')}
          </Link>
          <Link
            href='/ai-readiness'
            className='hover:text-mint-text transition-colors'
          >
            {t('footer.aicheck')}
          </Link>
          <Link
            href='/tech-radar'
            className='hover:text-mint-text transition-colors'
          >
            {t('footer.techradar')}
          </Link>
          {/* <Link href="/playbook" className="hover:text-mint-text transition-colors">
            {t("footer.playbook")}
          </Link> */}
          <Link
            href='/impressum'
            className='hover:text-mint-text transition-colors'
          >
            {t('footer.impressum')}
          </Link>
          <Link
            href='/datenschutz'
            className='hover:text-mint-text transition-colors'
          >
            {t('footer.datenschutz')}
          </Link>
          <Link href='/agb' className='hover:text-mint-text transition-colors'>
            {t('footer.agb')}
          </Link>
          <Link
            href='/nutzungsbedingungen'
            className='hover:text-mint-text transition-colors'
          >
            {t('footer.nutzungsbedingungen')}
          </Link>
          <a
            href='https://www.linkedin.com/company/haintz-it/'
            target='_blank'
            rel='noopener noreferrer'
            className='hover:text-mint-text transition-colors'
          >
            {t('footer.linkedin')}
          </a>
        </div>
      </div>
    </footer>
  );
}
